import { useIsAccountSelected } from '@features/accounts';
import { useIsAuthenticated } from '@features/authentication';
import { useIsProductionSelected } from '@features/productions';
import { ProtectionLevel } from '@router/types/ProtectionLevels';

export const useSession = () => {
    const isAuthenticated = useIsAuthenticated();
    const isAccountSelected = useIsAccountSelected();
    const isProductionSelected = useIsProductionSelected();

    let protectionLevel: ProtectionLevel = ProtectionLevel.NONE;

    if (isAuthenticated) {
        protectionLevel |= ProtectionLevel.AUTHENTICATED;
    }

    if (isAccountSelected) {
        protectionLevel |= ProtectionLevel.ACCOUNT_SELECTED;
    }

    if (isProductionSelected) {
        protectionLevel |= ProtectionLevel.PRODUCTION_SELECTED;
    }

    return {
        protectionLevel,
        isAuthenticated,
        isAccountSelected,
        isProductionSelected,
    };
};
